import classNames from 'classnames';
import type { ReactNode } from 'react';
import { SkeletonLoader } from '@/common/components/shared/skeleton-loader/SkeletonLoader';

interface SumByYearMonthCellProps {
  yearMonth: string;
  value: ReactNode;
  isCurrentColumn: (key: string) => boolean;
  loading: boolean;
}

export const SumByYearMonthCell = ({ yearMonth, value, isCurrentColumn, loading }: SumByYearMonthCellProps) => (
  <td
    className={classNames('text-right font-semibold tabular-nums', {
      'bg-amber-50': isCurrentColumn(yearMonth),
    })}
    data-year-month={yearMonth}
  >
    <SkeletonLoader loading={loading}>{value}</SkeletonLoader>
  </td>
);
